import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable(
  {
    providedIn: 'root'
  }
)
export class VerificationService
{
  private http = inject(HttpClient);
  readonly prefix = 'verify';

  verifyMail(baseUrl: string, mail: string): Observable<any>
  {
    const body = {mail: mail.trim()};
    const url = baseUrl + this.prefix + '/mail';
    console.log('HTTP POST: ' + url, body);
    return this.http.post<any>(url, body);
  }

  verifyMailCode(baseUrl: string, mail: string, code: string): Observable<any>
  {
    const body = {mail: mail.trim(), code};
    const url = baseUrl + this.prefix + '/mailCode';
    console.log('HTTP POST: ' + url, body);
    return this.http.post<any>(url, body);
  }
}
